import "./ShareLinkComponent.scss";
import {ENV} from "../../../constants";
import {Input} from "antd";
import {ShareAltOutlined,CopyOutlined,CheckOutlined} from "@ant-design/icons";
import {useCallback, useEffect, useState} from "react";
import {CommonService} from "../../../helpers";
import {useSelector} from "react-redux";
import {StateParams} from "../../../store/reducers";

interface ShareLinkComponentProps{
    jobDetails?:any;
    id?:any;
    copied?:any;
    setCopied?:any;
}

const ShareLinkComponent=(props:ShareLinkComponentProps)=>{
    const {jobDetails,id,setCopied,copied}=props;
    const {customersConfig}=useSelector((state:StateParams)=>state.meta);
    const [jobBoardUrl,setJobBoardUrl]=useState<any>(null);

    console.log(customersConfig,"CUSTOMER CONFIG")

    useEffect(() => {
        if(customersConfig){
            const currentUrl=window.location.origin;
            const currentCustomer=customersConfig?.find((customer:any)=>customer.job_board_url === currentUrl);
            setJobBoardUrl(currentCustomer?.job_board_url ||  ENV.API_JOB_BOARD_URL);
        }
    }, [customersConfig]);


    const handleCopy = useCallback((link) => {
        navigator.clipboard.writeText(link.link)
            .then(() => {
                setCopied({ [link.id]: true });
               CommonService.showToast('Copied to clipboard','success')
            })
            .catch(() => {
                CommonService.showToast('Failed to copy','error')
            });

    },[setCopied])


    const linkList=[
        {
            id:'facebook',
            title:"Facebook",
            link:`https://www.facebook.com/sharer/sharer.php?u=${jobBoardUrl}/job/${id}`
        },
        {
            id:'twitter',
            title:"Twitter",
            link:`https://twitter.com/intent/tweet?text=${jobDetails?.job_title}&url=${jobBoardUrl}/job/${id}`
        },
        {
            id:'linkedin',
            title:"LinkedIn",
            link:`https://www.linkedin.com/sharing/share-offsite/?url=${jobBoardUrl}/job/${id}`
        }
    ]

    return (
        <div className={'share-link-component'}>
            {linkList?.map((link:any)=>{
                return (
                    <div key={link.id} className={'share-link-card'}>
                        <div className={'share-link-title'}>{link.title}</div>
                        <div className={'share-link-wrapper'}>
                           <Input className={`share-link-input ${copied[link.id] ? 'active': ''}`} value={link.link} suffix={
                               <div className={'d-flex align-items-center justify-content-center'}>
                                   <div
                                       onClick={()=>handleCopy(link)}
                                       className={'mrg-right-15 mrg-t'}>
                                       {copied[link.id] ? <CheckOutlined/> :
                                       <CopyOutlined />}</div>
                                   <div
                                       style={{cursor:'pointer'}}
                                       onClick={()=>{
                                       window.open(link.link)
                                   }}><ShareAltOutlined /></div>
                               </div>
                           }/>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default ShareLinkComponent